<template>
  <v-select
    v-model="medicinesRoutineList"
    class="custom-v-select"
    multiple
    :filterable="false"
    :options="medicinesData"
    :placeholder="'Ketik minimal 3 huruf'"
    @search="onSearch"
  >
    <template slot="no-options">
      {{ result_text }}
    </template>
    <template slot="option" slot-scope="medicinesData">
      <div class="d-center">
        {{ medicinesData.text }}
      </div>
    </template>
    <template slot="selected-option" slot-scope="medicinesData">
      <div class="selected d-center">
        {{ medicinesData.text }}
      </div>
    </template>
  </v-select>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import _ from 'lodash'
Vue.component('VSelect', vSelect)

export default {
  name: 'SelectMedicines',
  data () {
    return {
      medicinesData: [],
      medicinesRoutineList: [],
      medicinesOptions: [],
      result_text: ''
    }
  },
  watch: {
    'medicinesRoutineList' (next) {
      this.$emit('selectedMedicines', this.medicinesRoutineList)
    }
  },
  methods: {
    onSearch (search, loading) {
      loading(true)
      this.handleRoutineMedicine(loading, search, this)
    },
    handleRoutineMedicine: _.debounce((loading, search, vm) => {
      const event = search
      if (event.length >= 3) {
        vm.$store.dispatch('patient/searchDrugs', event)
          .then((res) => {
            vm.medicinesData = res
            vm.medicinesData.forEach(function (v) {
              delete v.tableid
              delete v.val
              delete v.type
              delete v.has_interactions
            })
            if (res.length === 0) {
              vm.result_text = 'Obat tidak ditemukan'
            }
            loading(false)
          }).catch(() => {
            loading(false)
          })
      } else {
        loading(false)
        vm.result_text = 'Ketik minimal 3 huruf'
        vm.medicinesData = []
      }
    }, 200)
  }
}
</script>
